module.exports = __webpack_public_path__ + "static/media/main_small_3.a667f426.png";